import React, { useEffect, useState } from "react";
import { View, Text, StyleSheet } from "react-native";

import { padDigits } from "../../../helpers/utils";
import AppTheme from "../AppTheme";

export default function ManaStopwatch({ seconds }) {
  const [timeModel, setTimeModel] = useState({});

  const computeTime = () => {
    const tm =
      seconds > 0
        ? {
            hours: Math.floor(seconds / (60 * 60)),
            minutes: Math.floor((seconds / 60) % 60),
            seconds: Math.floor(seconds % 60),
          }
        : { hours: 0, minutes: 0, seconds: 0 };

    setTimeModel(tm);
  };

  useEffect(() => {
    computeTime();
  }, [seconds]);

  return timeModel.hours != undefined ||
    timeModel.minutes != undefined ||
    timeModel.seconds != undefined ? (
    <View style={styles.counterContainer}>
      <Text style={styles.h2}>{padDigits(timeModel.hours, 2)}:</Text>
      <Text style={styles.h2}>{padDigits(timeModel.minutes, 2)}:</Text>
      <Text style={styles.h2}>{padDigits(timeModel.seconds, 2)}</Text>
    </View>
  ) : null;
}

const styles = StyleSheet.create({
  counterContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "row",
  },
  h2: {
    fontFamily: "Courier",
    fontWeight: "600",
    fontSize: 20,
    lineHeight: 30,
    letterSpacing: 1,
    color: AppTheme.almostBlack,
  },
});
